import { PageHeader } from "@/CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import { HousingInspectionNotes as HousingInspectionNotesComponent } from "./HousingInspectionNotes";

const HousingInspectionNotes = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t("HOUSING_INSPECTION_NOTES")} sticky={false} />
      <Container fluid>
        <HousingInspectionNotesComponent />
      </Container>
    </>
  );
};

export default HousingInspectionNotes;


